import { Injectable } from '@angular/core';
import { DconConfigAPI } from '../config/config';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { DataService } from '../config/data.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class LegacyExtractService {
  nodeBaseUrl = DconConfigAPI.NODE_URL;
  instaceId: any;
  insertBatchKeyUrl = `${this._data.UI_ORDS}${
    DconConfigAPI.UI_BATCH_KEY
  }${'insert_batchkey_details?&'}${DconConfigAPI.UI_GRANT_TYPE}`;
  authorizationData: any;
  options: any;
  selectSourceVal: any;
  instanceData: any;
  projId: string;
  instanceName: any;
  submitInstaceResList: any;
  newBatchKeyInstance: any;
  tracksFromTable: any;
  configType: string = 'EXTRACT';
  tabval = new BehaviorSubject('select');
  batchKey: string = null;
  instanceList: string;
  configObj: any;
  batchKeyDetails: any;
  newBatchKeySourceSystem: any;
  fromTable: boolean = false;
  projectName: string;
  selectInstanceObs: any;
  onClickPassInstaceData: any;
  updatedInstaceValue: any;
  editInstaceValue: string = 'no';
  authToken: string;
  selectSourceObs: any;
  projIdArray: any;
  Base_Url: any;
  token: any;
  requestedBy: string;
  Base_UI_BOT = DconConfigAPI.UI_PATH;
  Base_DEV_PATH = DconConfigAPI.SW_ORDS_BASE_URL;
  saveStatus: boolean;
  applyInProgress: boolean = false;
  AutoExtractStatus: any;
  constructor(private https: HttpClient, private _data: DataService) {
    this._data.authProjectID.subscribe((val) => {
      this.projId = val;
      console.log('val', this.projId);
      this.requestedBy = this._data.loggedUserId;
    });

    this._data.token.subscribe((val) => {
      this.token = val;
      this.authToken = 'Bearer ' + this.token;
    });
  }

  getisTrainStopUrl() {
    const isTrainStopUrl = this._data.getisTrainStopUrl();
    return isTrainStopUrl;
  }

  getAutoExtractData() {
    const data = {
      autoExtractStatus: this._data.AutoExtractStatus,
      userRole: this._data.userRole,
    };
    return data;
  }

  getloggedinUser() {
    return this.requestedBy;
  }
  getAutoExtractStatus(projid): Observable<any> {
    this.projId = projid;
    this.Base_Url = this._data.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this._data.ordstAuthData;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_AUTO_EXTRACT_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Project: projid,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getConfigDetails(type: string): Observable<any> {
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_CONFIG_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Request_Type: type,
      Extract_Application: DconConfigAPI.API_VARIABLES.EBS, //'EBS'
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  onConfigSubmit(body): Observable<any> {
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.INSERT_BATCHKEY_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
    });
    const options = { headers: headers };
    return this.https.post(url, body, options);
  }

  getInstance(type: string): Observable<any> {
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_INSTANCE_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Source_Type: type,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  onLegacySubmit(body): Observable<any> {
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.INSERT_BATCHKEY_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
    });
    const options = { headers: headers };
    return this.https.post(url, body, options);
  }

  getBatchKeyDetails(batchKey): Observable<any> {
    const projId = sessionStorage.getItem('projectId');
    this.projId = projId;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_BATCHKEY_DETAILS_UI +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Project_Name: projId,
      Requested_By: this._data.loggedUserId,
      Request_Type: DconConfigAPI.API_VARIABLES.Request_Type_Extract, //"EXTRACT",
      Extract_Application: DconConfigAPI.API_VARIABLES.EBS, //'EBS',
      Batch_Key: batchKey,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getBatchKeyDetailsUI(): Observable<any> {
    const projId = sessionStorage.getItem('projectId');
    this.projId = projId;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_BATCHKEY_DETAILS_UI +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Project_Name: projId,
      Requested_By: this._data.loggedUserId,
      Request_Type: DconConfigAPI.API_VARIABLES.Request_Type_Extract, //"EXTRACT",
      Extract_Application: DconConfigAPI.API_VARIABLES.EBS,
      Batch_Key: this.batchKey,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getLoadBatchkeys(projid): Observable<any> {
    const projId = sessionStorage.getItem('projectId');
    this.projId = projId;
    this.Base_Url = this._data.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this._data.ordstAuthData;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_BATCHKEY_UI +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Project_Name: projId,
      Requested_By: this._data.loggedUserId,
      Request_Type: DconConfigAPI.API_VARIABLES.Request_Type_Extract, //"EXTRACT",
      Source: DconConfigAPI.API_VARIABLES.LEGACY, //"LEGACY"
    });
    console.log('headers issue in Legacy extract', headers);
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getInstanceDetails(type: string): Observable<any> {
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_INSTANCE_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Source_Type: type,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getExtractDetails(batchkey): Observable<any> {
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.LEGACY_EXTRACT +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Requested_By: this._data.loggedUserId,
      Batch_Key: batchkey,
      Authorization: this.authorizationData,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      ignoreInInterceptor: 'true',
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  // DONE
  onExtract(body): Observable<any> {
    // const url = this.Base_UI_BOT + DconConfigAPI.URL_PROPS.ODATA_JOBS_STARTJOBS;
    // const headers = new HttpHeaders({
    //   'Authorization': this.authToken,
    // });
    // const options = { headers: headers };
    // return this.https.post(url, body, options);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers: headers };

    const payload = {
      startInfo: body.startInfo,
      token: this.authToken,
      orgId: DconConfigAPI.OrganizationUnitId,
    };
    return this.https.post(
      DconConfigAPI.NODE_URL + '/uipath/uipath-server-config-start-jobs',
      payload,
      options
    );
  }

  onApplyTranform(body): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Batch_key: body,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      ignoreInInterceptor: 'true',
    });
    const options = { headers: headers };

    const url =
      this._data.UI_ORDS +
      DconConfigAPI.UI_BATCH_KEY +
      DconConfigAPI.URL_PROPS.GLOBAL_TRANSFORMATION +
      DconConfigAPI.UI_GRANT_TYPE;
    return this.https.get(url, options);
  }

  onExtractUpdate(body): Observable<any> {
    this.Base_Url = this._data.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.UPDATE_BATCHKEY_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
    });
    const options = { headers: headers };
    return this.https.put(url, body, options);
  }

  fetchModules(batchkey): Observable<any> {
    this.Base_Url = this._data.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_CONFIG_TRANSFORM_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Batch_key: batchkey,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  fetchTasksAndFiles(batchkey, app_short_name): Observable<any> {
    this.Base_Url = this._data.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_CONFIG_TRANSFORM_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Batch_key: batchkey,
      Application_Short_Code: app_short_name,
    });
    const options = { headers: headers };
    console.log(url);
    return this.https.get(url, options);
  }

  generateCSVFiles(batchkey, project): Observable<any> {
    //batchkey & project
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.ODI_LOADFILECREATION;
    const jsondata = {
      BatchKey: batchkey,
      Project: project,
    };
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
      'Access-Control-Allow-Headers': 'Content-Type',
      'Content-Type': 'application/json; charset=utf-8',
      ignoreInInterceptor: 'true',
    });
    const options = { headers: headers };
    return this.https.post(url, jsondata, options);
  }

  async uploadFileFromSFTP(filename, batchKey) {
    var jsonData = {
      filename: filename,
      host: this._data.sftpHost,
      port: this._data.sftpPort,
      path: this._data.sftpPath + '/',
      credentials: this._data.sftpCredentials,
      batchKey: batchKey,
    };
    console.log(jsonData);
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.GET_SFTP_FILE;
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      ignoreInInterceptor: 'true',
    });
    const options = { headers: headers };
    return this.https.post(url, jsonData, options);
  }

  async uploadFileToSFTP(data, filename, batchKey) {
    var jsonData = {
      fileData: data,
      filename: filename,
      host: this._data.sftpHost,
      port: this._data.sftpPort,
      path: this._data.sftpPath + '/',
      credentials: this._data.sftpCredentials,
      batchKey: batchKey,
    };
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.PUT_SFTP_FILE;
    const req = new HttpRequest('POST', url, jsonData, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        ignoreInInterceptor: 'true',
      }),
    });
    return this.https.request(req);
  }
  // **************************************************
  // Auto Exrtract and Auto Upload API's
  // **************************************************

  autoUpload(project, instance, data, user): Observable<any> {
    //batchkey & project
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.ODI_AUTO_UPLOAD;
    const payLoad = {
      project: project,
      Extract_seq: data.Auto_extract_details[0].extract_seq_no,
      Created_by: user,
      credentials: this._data.sftpCredentials,
      host: this._data.sftpHost,
      port: this._data.sftpPort,
    };
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      ignoreInInterceptor: 'true',
    });
    const options = { headers: headers };
    return this.https.post(url, payLoad, options);
  }

  autoExtract(project, instance, data): Observable<any> {
    //batchkey & project
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.ODI_AUTO_EXTRACT;
    const payLoad = {
      project: project,
      Extract_seq: data.Auto_extract_details[0].extract_seq_no,
      Created_by: this._data.loggedUserId,
    };
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      ignoreInInterceptor: 'true',
    });
    const options = { headers: headers };
    return this.https.post(url, payLoad, options);
  }

  insertAutoExtract(projid, payLoad): Observable<any> {
    this.Base_Url = this._data.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this._data.ordstAuthData;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.INSERT_AUTO_EXTRACT +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Project_Name: projid,
    });

    const options = { headers: headers };
    return this.https.post(url, payLoad, options);
  }

  getSelectedBatchTasks(): Observable<any> {
    this.Base_Url = this._data.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this._data.ordstAuthData;
    this.projId = this._data.projectID;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_BATCHKEY_DATA +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Project_Name: this.projId,
      Requested_By: this._data.loggedUserId,
      Request_Type: DconConfigAPI.API_VARIABLES.Request_Type_Extract,
      Source_Type: DconConfigAPI.API_VARIABLES.LEGACY,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  //https://dev-oracleofferingdfte.deloitte.com/Confighubapi/api/odi/getFileStatus

  getFileStatus(batchKey): Observable<any> {
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.GET_FILE_STATUS;
    this.projId = this._data.projectID;
    const payLoad = {
      batchkey: batchKey,
      project: this.projId,
    };
    return this.https.post(url, payLoad);
  }

  uploadXlsxFile(
    file: File,
    time: string,
    project_id: string
  ): Observable<any> {
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.UPLOAD_XLSX_FILE;
    const formData = new FormData();

    formData.append('file', file);
    formData.append('identifier', project_id);
    formData.append('requestedBy', this.requestedBy);
    formData.append('time', time);

    if (environment.isBasicAuth) {
      const token = localStorage.getItem('authToken');

      const headers = new HttpHeaders({
        Authorization: `Bearer ${token}`,
      });

      formData.append('isBasicAuth', 'true');

      return this.https.post(url, formData, { headers });
    }

    return this.https.post(url, formData);
  }
}
